import MmenuLight from 'mmenu-light';
import MicroModal from 'micromodal';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Swiper from 'swiper/bundle';
import {
    wrapGrid
} from 'animate-css-grid';

window.addEventListener('DOMContentLoaded', init);

function init() {
    offCanvas();
    animations();
    modals();
    slider();
    editorMenu();
    navOverlap();
    navLightmode();
    tabs();
    backgroundChanger();
    cookieBanner();
    checkMobile();
    popUp();
    modalBig();
}

function offCanvas() {
    // GLOBAL
    const canvas = document.querySelector('.c-off-canvas');
    const tlNav = gsap.timeline({
        ease: 'power4.out',
        paused: true
    });
    const tlFilter = gsap.timeline({
        ease: 'power4.out',
        paused: true
    });
    // END GLOBAL

    // NAV
    const navCanvas = document.querySelector('.c-off-canvas--nav');
    const navOpen = document.querySelector('.js-off-canvas--nav');
    const hamburger = document.querySelector('.c-nav__hamburger');
    const hamburgerActiveClass = 'c-nav__hamburger--active';
    if (navCanvas) tlNav.to(canvas, {
        autoAlpha: 1,
        duration: .1,
        display: 'block'
    }).to(navCanvas, {
        x: 0,
        duration: .3,
        display: 'flex'
    }).to('.c-nav', {
        zIndex: 101,
        duration: 0
    }, 0).to('.c-nav__dropdown, .c-nav__account', {
        display: 'none',
        duration: .1
    }, 0);
    // END NAV


    // FILTER
    const filterCanvas = document.querySelector('.c-off-canvas--filter');
    const filterOpen = document.querySelector('.js-off-canvas--filter');
    const filterClose = document.querySelector('.c-off-canvas__filter-close');
    const filterOpenTrigger = document.querySelector('.js-open-canvas--filter');

    if (filterCanvas) tlFilter.to(canvas, {
        autoAlpha: 1,
        duration: .1,
        display: 'block'
    }).to(filterCanvas, {
        x: 0,
        duration: .3,
        display: 'block'
    }).to('.c-nav__dropdown, .c-nav__account', {
        display: 'none',
        duration: .1
    }, 0);

    window.addEventListener('click', (e) => {
        let target = e.target;
        if (target == canvas || target == filterClose) toggleCanvas('close');
    });

    if (navOpen) navOpen.addEventListener('click', () => {
        toggleCanvas('nav');
    });

    if (filterCanvas) {
        filterOpen.addEventListener('click', () => {
            toggleCanvas('filter');
        });
        filterOpenTrigger.addEventListener('click', () => {
            window.dataLayer.push({'event': 'click_help_pop_up'});
            toggleCanvas('filter');
        });
    }
    // END FILTER

    function toggleCanvas(option) {
        if (option == 'nav') {
            if (tlNav.paused() || tlNav.reversed()) tlNav.play();
            else tlNav.reverse();
            hamburger.classList.toggle(hamburgerActiveClass);
        }
        if (option == 'filter')
            if (tlFilter.paused() || tlFilter.reversed()) tlFilter.play() && popUp('close');
            else tlFilter.reverse();
        if (option == 'close') {
            if (hamburger && hamburger.classList.contains(hamburgerActiveClass)) hamburger.classList.remove(hamburgerActiveClass);
            if (!tlNav.paused()) tlNav.reverse();
            if (!tlFilter.paused()) tlFilter.reverse();
        }
    }
    // END FUNCTIONS
}

function animations() {
    const images = gsap.utils.toArray('.c-img-grid__list>.js-openStyle');
    images.forEach((img) => {
        const anim = gsap.from(img, {
            autoAlpha: 0,
            duration: 2,
        });
        ScrollTrigger.create({
            trigger: img,
            animation: anim
        });
    });
}

function modals() {
    MicroModal.init({
        openTrigger: 'modal-open',
        closeTrigger: 'modal-close',
        openClass: 'c-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: false,
        awaitCloseAnimation: true,
    });
}

function slider() {
    new Swiper('.js-slider', {
        effect: 'fade',
        speed: 800,
        slidesPerView: 1,
        autoplay: {
            delay: 4000,
        },
    });
}

function editorMenu() {
    const editorMenu = document.querySelector('.js-mmenu');

    if (!editorMenu) return;

    const menu = new MmenuLight(editorMenu);
    const search = document.querySelector('.c-editor__search-title');
    const searchBox = document.querySelector('.c-editor__search-input');
    const resetMenuBtns = document.querySelectorAll('.js-mmenu-close');

    resetMenuBtns.forEach(e => e.addEventListener('click', () => {
        for (let i = 0; i < 100; i++) editorMenu.click()
    }))

    menu.navigation({
        title: editorMenu.dataset.title,
    });

    menu.offcanvas().open();

    setTimeout(() => {
        insertAfter(document.querySelector('.popup-content'), document.querySelector('.mm-ocd'))
        document.querySelector('.mm-ocd__backdrop').remove();
    });

    function insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    if (search) {
        const tl = gsap.timeline();
        tl.to(searchBox, {
            height: 'auto',
            duration: .2,
        }).reverse();
        search.addEventListener('click', () => {
            search.classList.toggle('c-editor__search-title--active');
            searchBox.querySelector('input').focus();
            tl.reversed(!tl.reversed());
        });
    }
}

function navOverlap() {
    const nav = document.querySelector('.c-nav');
    const overlap = document.querySelector('[data-overlap]');

    if (!overlap) return;

    const mediaQueryWidth = overlap.getAttribute('data-overlap');
    const mediaQuery = window.matchMedia('(min-width: ' + mediaQueryWidth + 'px)');

    nav.classList.add('c-nav--overlap')

    const height = () => {
        const screen = document.querySelector('.js-screen');
        screen.style.height = `${window.innerHeight}px`;
    }
    window.addEventListener('resize', height);
    height();

    mediaQuery.addListener(screenChanges);
    screenChanges(mediaQuery);

    function screenChanges(e) {
        if (e.matches) {
            nav.classList.add('c-nav--dark');
        } else {
            nav.classList.remove('c-nav--dark');
        }
    }
}

function navLightmode() {
    const nav = document.querySelector('.c-nav');
    const html = document.querySelector('html');
    const lightmode = document.querySelector('.js-lightmode');
    if (lightmode) nav.classList.add('c-nav--light'), html.style.background = '#F5F5F5';
}

function tabs() {
    const tabs = document.querySelector(".js-tabs");

    if (!tabs) return;

    const tabsBtns = tabs.querySelectorAll(".js-tabs__btn");
    const tabsContents = tabs.querySelectorAll(".js-tabs__content");

    function displayCurrentTab(current) {
        for (let i = 0; i < tabsContents.length; i++) {
            const activeClass = "c-account__btn--active";
            tabsContents[i].style.display = (current === i) ? "block" : "none";
            (current === i) ? tabsBtns[i].classList.add(activeClass): tabsBtns[i].classList.remove(activeClass);
        }
    }

    displayCurrentTab(0);

    tabs.addEventListener("click", event => {
        if (event.target.classList.contains('js-tabs__btn')) {
            for (let i = 0; i < tabsBtns.length; i++) {
                if (event.target === tabsBtns[i]) {
                    displayCurrentTab(i);
                    break;
                }
            }
        }
    });
}

function backgroundChanger() {
    const groups = document.querySelectorAll('.c-backgrounds__group');
    const bgLinks = '.c-backgrounds__item';
    const bgActiveClass = 'c-backgrounds__item--active';
    const closeModal = document.querySelector('.js-bg__close');
    const currentBg = document.querySelector('.js-bg__current');
    const currentBgSrcSet = document.querySelector('.js-bg__srcset__current');
    const currentFloor = document.querySelector('.js-floor__current');
    const currentFloorSrcSet = document.querySelector('.js-floor__srcset__current');

    let target;

    const changeActive = (e) => {
        if (e.target.classList.contains('c-backgrounds__select')) target = e.target.parentNode;
        else target = e.target;

        e.target.parentNode.querySelectorAll(bgLinks).forEach(link => link.classList.remove(bgActiveClass));
        target.classList.add(bgActiveClass);

        if (target.getAttribute('data-bgtype') == 'wall') {
            currentBg.src = target.getAttribute('data-bg').replace('.webp','.jpg');
            currentBg.setAttribute('data-rescale', target.getAttribute('data-bgRescale'));
            currentBgSrcSet.srcset = target.getAttribute('data-bg');
            storeBackground(target.getAttribute('data-bgColor'), 'wall');
        };

        if (target.getAttribute('data-bgtype') == 'floor') {
            currentFloor.src = target.getAttribute('data-bg').replace('.webp','.jpg');
            currentFloor.setAttribute('data-rescale', target.getAttribute('data-bgRescale'));
            currentFloorSrcSet.srcset = target.getAttribute('data-bg');
            if (target.getAttribute('data-bgTheme') == 'dark') {
                document.querySelectorAll('.o-btn--blur').forEach(button => { button.classList.remove('o-btn--blur-light'); button.classList.add('o-btn--blur-dark'); });
            } else {
                document.querySelectorAll('.o-btn--blur').forEach(button => { button.classList.remove('o-btn--blur-dark'); button.classList.add('o-btn--blur-light'); });
            }
            storeBackground(target.getAttribute('data-bgColor'), 'floor');
        }
    }

    groups.forEach(backgrounds => backgrounds.querySelectorAll(bgLinks).forEach(e => e.addEventListener('click', changeActive)));
    if (closeModal) closeModal.addEventListener('click', () => setTimeout(() => MicroModal.close('modal-background'), 50));
}

function cookieBanner() {
    const cookieName = 'cookieconsent';
    const cookieValue = 'set';
    const date = new Date();
    const btnAccept = document.querySelector('.js-cookie-accept');
    const btnDismiss = document.querySelector('.js-cookie-dismiss');
    if (btnAccept) btnAccept.addEventListener('click', accept);
    if (btnDismiss) btnDismiss.addEventListener('click', dismiss);

    if (cookieActive()) removeBanner();

    function accept() {
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        setCookie(date);
    }

    function dismiss() {
        date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
        setCookie(date);
    }

    function setCookie(date) {
        document.cookie = `${cookieName}=${cookieValue};expires=${date.toUTCString()};path=/`;
        removeBanner();
    }

    function removeBanner() {
        document.querySelector('.js-cookie-banner').remove();
    }

    function cookieActive() {
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(';');
        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie === `${cookieName}=${cookieValue}`) return true;
        }
        return false;
    }
}

function checkMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 1200px)');
    const mobilePopUp = document.querySelector('.c-mobile');
    const mobilePopUpClose = document.querySelectorAll('.js-mobile--close');
    const cookieName = 'mobile';
    const cookieValue = 'set';
    const date = new Date();
    mobilePopUpClose.forEach((e) => e.addEventListener('click', () => closePopUp('btn')));

    if (cookieActive()) closePopUp('init');

    function screen(e) {
        if (e.matches && !cookieActive()) openPopUp();
        else if (!cookieActive()) closePopUp('init');
    }

    function openPopUp() {
        if (!mobilePopUp.classList.contains('keepHidden')) mobilePopUp.style.display = 'flex';
    }

    function closePopUp(close) {
        if (close == 'init') mobilePopUp.style = '';
        else gsap.to(mobilePopUp, {
            opacity: 0,
            display: 'none',
            duration: .3,
            ease: 'power2.out'
        })

        if (close == 'btn' && !cookieActive()) {
            date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
            setCookie(date);
        }
    }

    function setCookie(date) {
        document.cookie = `${cookieName}=${cookieValue};expires=${date.toUTCString()};path=/`;
    }

    function cookieActive() {
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookies = decodedCookie.split(';');
        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie === `${cookieName}=${cookieValue}`) return true;
        }
        return false;
    }

    screen(mobileMediaQuery)
    mobileMediaQuery.addEventListener('change', screen);
}

function modalBig() {
    const modal = document.querySelector('.c-modal-big');
    if (!modal) return;

    const height = () => {
        const screen = document.querySelector('.c-modal-big');
        screen.style.setProperty('--height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', height);
    height();
}

window.popUp = function popUp(toggle) {
    const popUp = document.querySelector('.c-pop-up');

    if (!popUp) return;

    const delay = popUp.getAttribute('data-delay') * 1000;
    const popUpClose = document.querySelectorAll('.c-pop-up__close, .js-pop-up--close');
    let disableTogglePopUp = false;


    if (toggle == 'open') togglePopUp('open');
    if (toggle == 'close') togglePopUp('close');

    if (popUp && !toggle) {
        gsap.set(popUp, {
            display: 'none',
            yPercent: 100
        });

        popUpClose.forEach(e => e.addEventListener('click', () => {
            togglePopUp('close');
        }));

        setTimeout(() => {
            togglePopUp('open');
        }, delay);
    }

    function togglePopUp(option) {
        if (option == 'close') {
            gsap.to(popUp, {
                opacity: 0,
                yPercent: 100,
                duration: .3,
                display: 'none'
            });
            disableTogglePopUp = true;
        } else if (option == 'open' && !disableTogglePopUp) {
            gsap.to(popUp, {
                opacity: 1,
                yPercent: 0,
                duration: .3,
                display: 'block'
            });
        }
    }
}

const grid = document.querySelector('.c-img-grid__list');
if (grid) {
    const {
        forceGridAnimation
    } = wrapGrid(grid);
    window.animateGrid = function () {
        forceGridAnimation()
    }
}

